export const LIST_FILTER_NONE = '__none__';

function activeEmployeeTeams(employee) {
  const memberships = Array.isArray(employee?.team_memberships) ? employee.team_memberships : [];
  return memberships
    .filter((membership) => membership && membership.active !== false)
    .map((membership) => membership.team)
    .filter((team) => team?.name && team.active !== false);
}

function employeeSupervisorIds(employee) {
  const ids = new Set();
  for (const team of activeEmployeeTeams(employee)) {
    const leaderId = Number(team.leader?.id || team.leader_id || 0);
    if (leaderId) ids.add(leaderId);
  }
  return [...ids];
}

export function employeeDepartmentNames(employee) {
  const names = new Set();
  const laborAssignments = Array.isArray(employee?.factory_department_assignments)
    ? employee.factory_department_assignments
    : [];
  for (const assignment of laborAssignments) {
    if (assignment?.active === false) continue;
    const name = assignment?.factory_department?.department?.name;
    if (name) names.add(name);
  }
  const authAssignments = Array.isArray(employee?.factory_assignments) ? employee.factory_assignments : [];
  for (const assignment of authAssignments) {
    if (assignment?.department_name) names.add(assignment.department_name);
  }
  return [...names];
}

export function collectEmployeeFilterOptions(employees) {
  const teams = new Map();
  const supervisors = new Map();
  const departments = new Set();
  const list = Array.isArray(employees) ? employees : [];

  for (const employee of list) {
    for (const name of employeeDepartmentNames(employee)) departments.add(name);
    for (const team of activeEmployeeTeams(employee)) {
      teams.set(String(team.id), team.name);
      const leaderId = Number(team.leader?.id || team.leader_id || 0);
      if (!leaderId) continue;
      const leaderName = [team.leader?.first_name, team.leader?.last_name].filter(Boolean).join(' ').trim();
      supervisors.set(String(leaderId), leaderName || `Empleado #${leaderId}`);
    }
  }

  const byLabel = (a, b) => a.label.localeCompare(b.label, 'es');
  return {
    teams: [...teams.entries()].map(([value, label]) => ({ value, label })).sort(byLabel),
    supervisors: [...supervisors.entries()].map(([value, label]) => ({ value, label })).sort(byLabel),
    departments: [...departments].sort((a, b) => a.localeCompare(b, 'es')),
  };
}

export function employeeMatchesListFilters(employee, filters = {}) {
  const teams = activeEmployeeTeams(employee);

  if (filters.team === LIST_FILTER_NONE) {
    if (teams.length > 0) return false;
  } else if (filters.team && !teams.some((team) => String(team.id) === String(filters.team))) {
    return false;
  }

  const supervisorIds = employeeSupervisorIds(employee);
  if (filters.supervisor === LIST_FILTER_NONE) {
    if (supervisorIds.length > 0) return false;
  } else if (filters.supervisor && !supervisorIds.includes(Number(filters.supervisor))) {
    return false;
  }

  if (filters.department && !employeeDepartmentNames(employee).includes(filters.department)) {
    return false;
  }

  return true;
}
